import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=9a2e2798&scoped=true"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js"
import style0 from "./YouTubeVideo.vue?vue&type=style&index=0&id=9a2e2798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2e2798",
  null
  
)

export default component.exports